module.exports = __webpack_public_path__ + "./docs/img/icon-big-search.74d2f7f4fed77a4741e649d966863496.svg";